// Keeping a figure in order inside Arabic: a number, a sign, a % or a unit
// read left to right in every language.

// Left-to-right isolate and its end, by code point: the characters
// themselves are invisible and the compiler rightly refuses them in source.
const ISOLATE_LTR = String.fromCodePoint(0x2066);
const POP_ISOLATE = String.fromCodePoint(0x2069);

/** A figure kept left to right inside Arabic, its sign, % or unit in place. */
export function leftToRight(text: string): string {
	return `${ISOLATE_LTR}${text}${POP_ISOLATE}`;
}
